import script from "./DetailResultDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailResultDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DetailResultDialog.vue?vue&type=style&index=0&id=9745357e&scoped=true&lang=css"
import "./DetailResultDialog.vue?vue&type=style&index=1&id=9745357e&lang=css"
import "./DetailResultDialog.vue?vue&type=style&index=2&id=9745357e&lang=sass"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9745357e"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QBtn,QTooltip,QTable,QIcon,QSelect,QTh,QTd,QField});qInstall(script, 'directives', {ClosePopup});
